<template>
  <div v-loading="listLoading" class="tabList">
    <div v-show="propsObj.link" class="search-result">
      <div><span class="result-title">{{ wd | titleFilter }}</span> - 名师</div>
    </div>
    <div v-if="dataList && dataList.length>0" class="list">
      <div class="list-box">
        <div v-for="(item, index) in dataList" :key="index" class="list-item" @click="openWindow(item)">
          <div class="imgbox">
            <img v-if="item.profilePhotoPath" :src="item.profilePhotoPath" class="imgsrc" @error="defoutImg($event)">
            <img v-else :src="require('@/assets/img/tx.png')" class="imgsrc">
          </div>
          <div class="text">
            <div class="title">
              {{ item.name }}  <span class="right" />
            </div>
            <p>{{ item.stage | stageFormat }}</p>
            <p> {{ item.professor | professorFormat }}  </p>
            <p>{{ item.schoolName }}</p>
            <!-- <div class="icon-box">
              <span> <img class="icon" src="@/assets/img/icon1.png" alt=""> 资源数：213</span>
              <span> <img class="icon" src="@/assets/img/icon2.png" alt=""> 访问数：213</span>
              <span> <img class="icon" src="@/assets/img/icon3.png" alt=""> 下载数：12131</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <global-empty
      v-else
      :label="`暂无数据~`"
      link-it="3"
      height="200"
    />
    <pagination
      v-show="propsObj.link"
      :total="searchForm.total"
      :page.sync="searchForm.pageNum"
      :limit.sync="searchForm.pageSize"
      @pagination="pageCurriculumList"
      @handleSizeChange="handleSizeChange"
    />
  </div>
</template>
<script>
import { getAppList } from '@/api/search';
import ENVIRONMENT from '@/utils/environment';

export default {
  name: 'TabList',
  filters: {
    stageFormat(val) {
      switch (val) {
        case '1':
          return '小学';
        case '2':
          return '初中';
        case '3':
          return '高中';
        default:
          break;
      }
    },
    professorFormat(val) {
      switch (val) {
        case 44:
          return '正高级教师';
        case 45:
          return '高级教师';
        case 46:
          return '一级教师';
        case 47:
          return '二级教师';
        case 48:
          return '三级教师';
        case 57:
          return '无';
        default:
          break;
      }
    }
  },
  props: {
    propsObj: {
      default: Object,
      type: Object
    },
    wd: {
      default: String,
      type: String
    },
    searchClick: {
      default: String,
      type: String
    }
  },
  data: () => {
    return {
      link: '',
      searchForm: {
        pageNum: 0,
        pageSize: 10,
        total: 0
      },
      listLoading: true,
      dataList: []
    };
  },
  watch: {
    searchClick(val) {
      console.log('点击了:' + val);
      this.getList();
    },
    $route() {
      this.getList();
    }
  },
  mounted() {
    console.log('教师:' + this.wd);
    this.getList();
  },
  methods: {
    // 头像为null或者加载错误时设置默认头像
    defoutImg(event) {
      event.target.src = require('@/assets/img/tx.png');
    },
    async getList() {
      this.listLoading = true;
      if (!this.propsObj.link) {
        this.searchForm.pageSize = 4; // 全部类型只查询四条
      }
      const params = {
        code: 'S03',
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize,
        q: this.wd
      };
      await getAppList(params).then(res => {
        this.dataList = res.data.S03.list;
        this.searchForm.total = res.data.S03.total;
        setTimeout(() => {
          var list = document.getElementsByClassName('list-box');
          if (this.dataList.length < 1) {
            this.height = 150;
          } else if (list[0].offsetHeight) {
            this.height = list[0].offsetHeight;
          }
          const data = {
            result: this.searchForm.total,
            height: this.height
          };
          this.listLoading = false;
          window.parent.postMessage(data, '*');
        }, 500);
      });
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.getList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.getList();
    },
    handlerLink() {
    // this.$router.push('/'+this.propsObj.link+'/'+this.propsObj.propsId);
    },
    openWindow(item) {
      console.log(item);
      window.open(ENVIRONMENT.teacherUrl + '/#/homePage/personalHomepage?teacherCode=' + item.code);
    }
  }
};
</script>
<style scoped lang="scss">
.list{
  padding: 20px 0;
  .list-box{
    display: flex;
    flex-wrap: wrap;
  }
  .list-item {
    display: flex;
    justify-content: space-between;
    background: #F3FAFF;
    margin-bottom: 20px;
    flex-wrap: wrap;
    padding: 20px;
    width: 47.5%;
    margin-left: 20px;
    cursor: pointer;
    &:nth-child(even){
       padding-left: 20px;
    }
    &:nth-child(odd){
       padding-right: 20px;
    }
    .imgbox {
      width: 114px;
      height: 114px;
      .imgsrc {
        border-radius: 20px;
        width: 100%;
        height: 100%;
      }
    }
    .text {
      flex: 1;
      margin-left: 20px;
      line-height: 24px;
      p{
        width: 340px;
        height: 28px;
        line-height: 28px;
        overflow:hidden; //超出的文本隐藏
        text-overflow:ellipsis; //溢出用省略号显示
        white-space:nowrap; //溢出不换行

      }
      .title{
        font-size: 16px;
        font-weight: bold;

      }
    }
  }
}
.search-result{
  display: flex;
  justify-content: space-between;
  padding: 20px 0 0 0;
  margin: 0 16px 0 20px;
  font-weight: bold;
  font-size: 18px;
  div{
    font-size: 18px;
    color: #787878;
    font-weight: 500;
  }
  .result-title{
  font-weight: bold !important;
  font-size: 18px !important;
  }
  span{
    color: #0082F1;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
}
.text > p {
  font-weight: 400;
  color: #787878;
  font-family: Microsoft YaHei;
}
.title{
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #007AFC;
}

.icon{
  width: 18px;
  height: 16px;
  margin-right: 4px;
}
.icon-box{
  margin-top: 20px;
  margin-left:-30px;
  span{
    margin-left: 30px;
    height: 13px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #787878;
  }
}
</style>

